<template>
    <div id="step1">
    <h3><img src=".././assets/images/step1-title.svg"> 品番を入力</h3>
        <div>
<!--            <p style="font-size: 1.2rem;margin-bottom:0px;">{{$store.state.price_data.total_price}}</p>-->
            <p style="color:red;font-size: 0.8rem; margin:0;">{{error_message}}</p>
            TT&nbsp;&nbsp;<b-form-input type="number" pattern="\d*" @keydown.enter="trigger" id="number_text" class="input_item_number" v-model="item_number" placeholder="品番入力" v-on:keyup="checkItemNumber()"></b-form-input>
<!--            &nbsp;&nbsp;<b-button style="display:" v-on:click="checkItemNumber()" id="NowSearch" class="search_btn" variant="success">検索</b-button>&nbsp;&nbsp;-->
            <span style="font-size: 0.8rem;">&nbsp;&nbsp;{{message}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'STEP1',
        data() {
            return {
                message:'',
                //item_number:this.getParam('id'),
                item_number:'',
            }
        },
        created : function () {
        },
        watch: {
            /**
             * 全角→半角
             * @param v
             */
            item_number : function(v) {
                this.item_number = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                    return String.fromCharCode(s.charCodeAt(0) - 65248)
                }).toUpperCase()
            },
        },
        computed: {
            error_message: {
                get: function () {
                    return this.$store.state.error_message
                },
            },
        },
        mounted: function () {
            if(this.getParam('id')){
                this.item_number = this.getParam('id')
            }else{
                this.item_number = ''
            }
        },
        methods : {
            getParam:function(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " ")).replace('TT','');
            },
            /**
             * 品番データがあるかチェック
             */
            checkItemNumber : function(get_id){
                const xlsx_data = this.$store.state.xlsx_data
                //let item_number = this.$store.state.step1_data.item_number

                if (this.isset(xlsx_data.item_data) && xlsx_data.item_data['TT'+this.item_number]) {
                    this.message = '品番データがあります'
                    let item_number = this.item_number
                    if(
                        item_number.match(/S$/) ||
                        item_number.match(/W$/) ||
                        item_number.match(/s$/) ||
                        item_number.match(/w$/)
                    ){
                        item_number = item_number.slice( 0, -1 )
                    }
                    this.$store.commit('updateItemNumber', item_number)
                    this.$store.commit('updateSearchData', xlsx_data.item_data['TT'+item_number])
                } else {
                    this.message = '品番データが見つかりませんでした'
                    this.$store.commit('updateItemNumber', this.item_number)
                    this.$store.dispatch('priceCheck')
                }

            },
            /**
             *  値の有無をチェック
             *  phpのisset()に相当
             *  @param  data    値
             *  @return         true / false
             *
             */
            isset : function(data){
                if(data === "" || data === null || data === undefined){
                    return false;
                }else{
                    return true;
                }
            },

            /**
             * エンターキー対応
             * @param event
             */
            trigger: function(event) {
                // 日本語入力中のEnterキー操作は無効にする
                if (event.keyCode !== 13) return
                // 実行したい処理
                this.checkItemNumber()
            }
        }
    }
</script>

<style scoped>

</style>